import React from 'react';
import { UnitAvailabilityTypes } from '../../UnitAvailabilityTypes';
import { Icon } from '../../../../../../utilities/icomoon-css';
import { ALERT_MODAL_CONFIG } from '../constants/viewRatesFilterConfig';
import { Button } from '@codeparva/ui-components-library';
import { navigate } from 'gatsby';

export const AlertModal = ({
  alertModalInfo,
  setAlertModalInfo,
  logOutHandler,
  locationStrapiId,
  facilityName,
  facilityIdDetails,
  selectedLocation,
  unitsData,
}: UnitAvailabilityTypes.TAlertModalTypes) => {
  const { attributes: { location_state = '', location_city = '' } = {} } =
    selectedLocation || {};

  const closeModal = () => {
    setAlertModalInfo({
      ...alertModalInfo,
      showModal: false,
      currentUnitTypeData: {},
      type: '',
    });
  };

  const handleLoginToDifferentAccount = () => {
    logOutHandler();
    closeModal();
    navigate('../account/login', {
      state: { facility_sms_id: facilityIdDetails?.selectedFacilityId },
    });
  };

  const handleRentOrReserve = () => {
    logOutHandler();
    const navigationEndpoint =
      alertModalInfo?.type === ALERT_MODAL_CONFIG.rent ? 'move-in' : 'reserve';
    const source =
      alertModalInfo?.type === ALERT_MODAL_CONFIG.rent
        ? 'navigateMoveIn'
        : 'navigateReservation';
    navigate(
      `/${location_state.toLowerCase()}/${location_city.toLowerCase()}/view-rates/${navigationEndpoint}`,
      {
        state: {
          locationStrapiId,
          facilityName,
          individualUnitTypeData: { ...alertModalInfo?.currentUnitTypeData },
          clickedPath: navigationEndpoint,
          source,
          unitsData,
        },
      }
    );
    closeModal();
  };

  return (
    <div className={`modal ${alertModalInfo.showModal ? 'is-active' : ''}`}>
      <div className="modal-background" />
      <div className="modal-card modalCard">
        <div className="modal-card-head modalHead is-flex is-justify-content-start">
          <div className="warningEnclosure">
            <Icon name="tfw-danger-circle-cp" size={20} color="#F44336" />
            <span className="warningHeader">
              {ALERT_MODAL_CONFIG.warningTitle}
            </span>
          </div>
          <div onClick={closeModal} className="closeModal">
            <Icon name="tfw-close-circle-cp" size={16} color="#4F4F4F" />
          </div>
        </div>
        <div className="modal-card-body modalBody">
          <div className="warningMessage">
            {ALERT_MODAL_CONFIG.warningMessage}
          </div>
          <div className="warningNote">
            <span>Note: </span>
            <span>{ALERT_MODAL_CONFIG.warningNote}</span>
          </div>
        </div>
        <div className="modal-card-foot modalFooter is-flex is-justify-content-center">
          <Button
            className="loginToDifferentAccount"
            onClick={handleLoginToDifferentAccount}
          >
            {ALERT_MODAL_CONFIG.loginToDiffAccount}
          </Button>
          <Button
            className={`${alertModalInfo?.type}ALertButton`}
            onClick={handleRentOrReserve}
          >
            {alertModalInfo?.type}
          </Button>
        </div>
      </div>
    </div>
  );
};
